import * as React from 'react';
var UitkTableCellContext = React.createContext({});
export { UitkTableCellContext as default };